import React from "react";
import "../styles/Contact.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";

function Contact() {
  return (
    <div className="container">
      <div className="top-text-container">
        <h1>Contact me</h1>
      </div>
      <form
        className="email-box"
        action="https://formsubmit.co/maryam.bani-otero@hotmail.com"
        method="POST"
      >
        {/* Disable Captcha */}
        <input type="hidden" name="_captcha" value="false"></input>
        {/* Success Message Link */}
        <input type="hidden" name="_next" value="/thanks" />
        {/* Form */}
        <div className="from-container">
          <label for="emailInfo" className="form-label">
            From:
          </label>{" "}
          <input
            type="email"
            className="form-input"
            name="email"
            id="emailInfo"
            placeholder="email@address.com"
            required
          />
        </div>

        <div className="subject-container">
          {" "}
          <label for="subject" className="subject-line" >
            Subject :{" "}
          </label>
          <input type="text" name="subject" id="subject" placeholder="subject"/>
        </div>
        <div className="message-container">
          {" "}
          {/* <label for="message" class="message-label">
            Message
          </label> */}
          <textarea placeholder="write something cool 😎"class="message-box" name="message" id="message" required  />
        </div>
        <div className="button-container">
        <button>
        <div className="send-text">Send</div>
        <div className="ticker-container">
          <div className="ticker-wrapper">
          <div className="ticker-items">
          <div className="ticker-transition">
              <span className="ticker-item">Send</span>
              <span className="ticker-item">Send</span>
              <span className="ticker-item">Send</span>
              <span className="ticker-item">Send</span>
              <span className="ticker-item">Send</span>
              <span className="ticker-item">Send</span>
              <span className="ticker-item">Send</span>
              <span className="ticker-item">Send</span>
              <span className="ticker-item">Send</span>
            </div>
          </div>
          </div>
        </div>
        </button>


        </div>
      </form>
      <div>
        <div className="bottom-text-container">
          or <br />
          you can contact me at{" "}
          <a href="mailto:maryam.bani-otero@hotmail.com">
            maryam.bani-otero@hotmail.com
          </a>
          <div className="contact-icons">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://github.com/maryambani"
              className="icon"
            >
              <FontAwesomeIcon icon={faGithub} />
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/in/maryam-bani-otero/"
              className="icon"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
